import React, { useEffect } from "react";
import { IonApp, IonRouterOutlet } from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { Route, Switch } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CardView from "./pages/CardView";
import Loading from "./pages/Loading";
import VerifyEmail from "./pages/VerifyEmail";
import Settings from "./pages/Settings";
import ResetPassword from "./pages/ResetPassword";
import LandingPage from "./pages/LandingPage";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Capacitor } from "@capacitor/core";
import { ModalProvider } from "./contexts/ModalContext";

import "./theme/global.scss";
import "@radix-ui/themes/styles.css";
import { Theme } from "@radix-ui/themes";
import EditCard from "./pages/EditCard";
import { Toaster } from "./components/ui/toaster";
import ForgotPassword from "./pages/ForgotPassword";
import SetPassword from "./pages/SetPassword";

const App: React.FC = () => {
  useEffect(() => {
    // force dark mode
    document.body.classList.toggle("dark", true);

    const setupApp = async () => {
      const platform = Capacitor.getPlatform();
      console.log("platform " + platform);

      try {
        // Setup status bar
        if (platform === "ios" || platform === "android") {
          await StatusBar.setOverlaysWebView({ overlay: true });
          await StatusBar.setStyle({ style: Style.Dark });
          await StatusBar.setBackgroundColor({ color: "#00000000" });
        }
      } catch (error) {
        console.log("StatusBar not available:", error);
      }

      // Hide splash screen after a short delay to ensure UI is ready
      // This prevents the zoom effect by hiding it quickly
      if (platform !== "web") {
        setTimeout(async () => {
          try {
            await SplashScreen.hide({
              fadeOutDuration: 300,
            });
          } catch (error) {
            console.log("SplashScreen not available:", error);
          }
        }, 100);
      }
    };

    setupApp();
  }, []);

  return (
    <IonApp>
      <Theme>
        <Toaster />
        <ModalProvider>
          <IonReactRouter>
            <IonRouterOutlet>
              <Switch>
                <Route path="/" component={Login} exact={true} />
                <Route path="/landing" component={LandingPage} exact={true} />
                <Route path="/login" component={Login} exact={true} />
                <Route path="/register" component={Register} exact={true} />
                <Route path="/loading" component={Loading} exact={true} />
                <Route
                  path="/verify-email"
                  component={VerifyEmail}
                  exact={true}
                />
                <Route
                  path="/reset-password"
                  component={ResetPassword}
                  exact={true}
                />

                <Route
                  path="/forgot-password"
                  component={ForgotPassword}
                  exact={true}
                />
                <Route
                  path="/set-password"
                  component={SetPassword}
                  exact={true}
                />
                <Route path="/settings" component={Settings} exact={true} />
                <Route path="/create" component={EditCard} exact={true} />
                <Route path="/card/:id" component={CardView} />
              </Switch>
            </IonRouterOutlet>
          </IonReactRouter>
        </ModalProvider>
      </Theme>
    </IonApp>
  );
};

export default App;
